import { gray } from '@ant-design/colors';
import { HomeOutlined, DownOutlined, CopyOutlined } from '@ant-design/icons';
import { Breadcrumb, Tooltip, Dropdown, Button } from 'antd';
import { Link, useParams, useLocation } from 'react-router-dom';
import { FunctionComponent, useMemo } from 'react';
import { capitalCase } from 'change-case';
import { onClickCopy } from 'packages/lib/utils/on-click-copy';
import { useRecoilValue } from 'recoil';
import { personaAtom } from 'packages/at-shell/state/recoil/ui';
import { useTenantBasepath } from 'packages/lib/auth/is-path';
import { isInternalPath } from 'packages/lib/auth/is-path';

export interface ToolRouteParams {
  extraction_token?: string;
  task_token: string;
}
export const Breadcrumbs: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const path = useLocation().pathname;
  const persona = useRecoilValue(personaAtom);
  const pathParts = path.split('/');
  const basePath = useTenantBasepath();
  const toolType = isInternalPath(basePath) ? pathParts[1] : pathParts[2];
  const tool = capitalCase(toolType);
  const { task_token } = useParams<ToolRouteParams>();
  const breadcrumbs = useMemo(() => {
    const crumbs = [
      {
        key: '/',
        title: (
          <Tooltip title="Go home">
            <Link
              to={basePath}
              style={{
                color: gray[1],
              }}
            >
              <HomeOutlined style={{ marginRight: '0.25rem' }} />
            </Link>
          </Tooltip>
        ),
      },
      {
        key: `${tool}`,
        title: !task_token ? (
          <span data-testid="tool-page-name" style={{ color: 'white' }}>
            {tool}
          </span>
        ) : (
          <Dropdown
            placement="bottom"
            arrow={!!task_token}
            menu={
              !task_token
                ? undefined
                : {
                    items: [
                      {
                        key: `${tool}-breadcrumbs-dropdown-share-view`,
                        label: (
                          <Button
                            type="text"
                            style={{
                              textDecoration: 'none',
                              padding: 0,
                              margin: 0,
                              height: 'auto',
                            }}
                            onClick={(): void =>
                              void onClickCopy(
                                `${window.location.origin}${path}`,
                                'Read-only viewer link'
                              )
                            }
                          >
                            Copy Viewer Link
                          </Button>
                        ),
                        icon: <CopyOutlined />,
                      },
                    ],
                  }
            }
          >
            <Button
              type="text"
              onClick={(e): void => e.preventDefault()}
              style={{
                color: 'white',
                textDecoration: 'none',
                padding: 0,
                margin: 0,
                height: 'auto',
              }}
            >
              {tool}
              <span
                style={{
                  color: gray[1],
                }}
              >
                <span style={{ margin: '0 0.5rem 0 0.75rem' }}>/</span>{' '}
                {capitalCase(persona)} Mode
              </span>
              <DownOutlined style={{ color: gray[1], marginLeft: '0.5rem' }} />
            </Button>
          </Dropdown>
        ),
      },
    ];
    return crumbs;
  }, [basePath, path, persona, task_token, tool]);
  return (
    <div
      style={{
        marginLeft: '1.75rem',
        fontSize: '1rem',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Breadcrumb
        separator={
          <span
            style={{ color: gray[1], margin: '0 0.5rem', userSelect: 'none' }}
          >
            /
          </span>
        }
        items={breadcrumbs}
      ></Breadcrumb>
    </div>
  );
};
